{
  "Analyze": "Analysera",
  "Assignments": "Tilldelat",

  "Category": "Kategori",
  "Clear All": "Rensa Alla",
  "Content": "Content",
  "Completed": "Avslutade",
  "CompletedOn": "Avslutade på",
  "Completion Rate": "% Avslutade",
  "Completions": "Avslutade",

  "Date Completed":  "Datum Avslutade",

  "Estimated time to complete the learning item": "Ungefärlig tid för att slutföra ett lärobjekt",

  "Expired": "Utgången",
  "ExpiredOn": "Utgången på",

  "Learners": "Teammedlemmar",
  "Learning Items": "Lärobjekt",
  "Learning Type": "Lärtyp",
  "Year": "År",

  "Name": "Namn",
  "No": "Nej",
  "Not Completed": "Ofullständig",
  "Number of learning items completed by learner": "Antal lärobjekt avslutade av teammedlem",
  "Number of learning items started by learner": "Antal lärobjekt påbörjade av teammedlem",
  "Number of team members assigned": "Antal teammedlemmar tilldelade content",
  "Number of team members started learning item": "Antal teammedlemmar som påbörjat ett lärobjekt",
  "Number of team members that completed full assigment": "Antal teammedlemmar som slutfört tilldelat content",
  "Date learning item was completed": "Datum när lärobjektet avslutades",
  "Estimated time to complete learning item": "Ungefärlig tid för att avsluta lärobjektet",

  "Progress": "Progress",

  "Required": "Krav",

  "Search Assignments": "Sök tilldelat",
  "Search Learner": "Sök teammedlem",
  "Search Learners": "Sök teammedlem",
  "Search Learning": "Sök lärobjekt",
  "Standard": "Standard",
  "Strategic": "Strategic",
  "Started": "Påbörjade",
  "Status": "Status",

  "empty-state-after-processed-title": "Hittade inga resultat",
  "empty-state-after-processed-subtitle": "Justera dina sökalternativ för att hitta det du letar efter",
  "empty-state-no-data-title": "Så snart användaren kommit igång hittar du data här",
  "empty-state-no-data-subtitle": "Fundera på hur du kan stödja denna användare i deras lärupplevelse så länge",
  "empty-state-clear-filters-action": "Rensa filter",
  "empty-state-no-data-found": "Här finns inga data ännu",

  "Team": "Team",
  "Time": "Tid",
  "Title": "Titel",
  "Total number of hours spent on learning": "Totalt antal timmar lagda på lärande",
  "Total Time": "Total Tid",
  "Type": "Type",


  "Yes": "Ja",

  "Joined": "Aktiverades",
  "Last active": "Senast aktiv",
  "Average progress": "Genomsnittlig progress",
  "Time spent": "Lagd tid",
  "learnings-count": "{{count}} lärobjekt",
  "completions": "{{completions}} <0>av {{total}}</0>",
  "External item": "External item",

  "Reflections": "Reflections",
  "Active learners": "Active learners",
  "Weekly goal achievers": "Weekly goal achievers",
  "Total reflections": "Total reflections",
  "Total time": "Total time",
  "Week": "Week"
}
